import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-29df4fea"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "spin"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img",
  src: _imports_0
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "general" }
const _hoisted_5 = { class: "alert alert-dismissible alert-success" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "alert-heading" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check" }),
  /*#__PURE__*/_createTextVNode(" Ingreso Actualizada Exitosamente! ")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Detalles de Ingreso", -1))
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Datos Generales")
], -1))
const _hoisted_10 = { class: "grid" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "expedienteNo"
}, "Expediente No.:", -1))
const _hoisted_12 = { class: "grid" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-edit" }, null, -1))
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Actualizar ")
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1))
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Eliminar ")
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Navbar),
    (_ctx.cargando)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_4, [
      _withDirectives(_createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleAlert())),
          type: "button",
          class: "btn-close",
          "data-bs-dismiss": "alert"
        }),
        _hoisted_6
      ], 512), [
        [_vShow, _ctx.showAlert]
      ]),
      _createElementVNode("form", null, [
        _createElementVNode("fieldset", null, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", null, [
                _hoisted_11,
                _withDirectives(_createElementVNode("input", {
                  id: "expedienteNo",
                  type: "expedienteNo",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.ingreso.expedienteNo) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.ingreso.expedienteNo]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", {
              class: "btn btn-success",
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.handleUpdate()), ["prevent"])),
              disabled: 
              !_ctx.ingreso.fecha ||
                !_ctx.ingreso.ano ||
                !_ctx.ingreso.mes ||
                !_ctx.ingreso.medico ||
                !_ctx.ingreso.expedienteNo
            
            }, _hoisted_16, 8, _hoisted_13),
            _createElementVNode("button", {
              class: "btn btn-danger",
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.handleDelete()), ["prevent"]))
            }, _hoisted_19)
          ])
        ])
      ])
    ], 512), [
      [_vShow, !_ctx.cargando]
    ])
  ], 64))
}